define("calendar/components/calendar/future-trends/body", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class={{concat-classes "cCA--futureTrends__body" (unless @showFutureTrendsDropdown "u--hide")}}>
    <div class="cCA--futureTrends__content__header">
      <h3 class="u--m__0">
        {{t "calendar.future_trends.title"}}
        <span>
          {{svg-jar "info" class="o--icon"}}
          <EmberTooltip @event="hover">
            {{t "calendar.future_trends.tooltip"}}
          </EmberTooltip>
        </span>
      </h3>
      <p class="u--m__0 u--text--sm">{{t "calendar.future_trends.sub_title" dateRange=@dateRangeFormatted}}</p>
    </div>
    {{#if @isLoading}}
      <div class="cCA--futureTrends__content__loading">
        <Shared::Ui::CalculatingState
          @text={{t "calendar.future_trends.loading"}}
          class="u--text--light u--text--center"
        />
      </div>
    {{else if @todaysTopHashtags.length}}
      <div class="cCA--futureTrends__content__items">
        {{#each @todaysTopHashtags as |trend|}}
          <Calendar::FutureTrends::Trend @closeAction={{@closeAction}} @trend={{trend}} />
        {{/each}}
      </div>
      <Calendar::FutureTrends::Footer @closeAction={{@closeAction}} />
    {{else}}
      <div class="cCA--futureTrends__content__error">
        {{svg-jar "warning" class="o--icon o--icon--lg"}}
        <p>{{t "alerts.generic_error_message"}}</p>
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "OsePQnIL",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"cCA--futureTrends__body\",[52,[51,[30,1]],\"u--hide\"]],null]],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCA--futureTrends__content__header\"],[12],[1,\"\\n    \"],[10,\"h3\"],[14,0,\"u--m__0\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"calendar.future_trends.title\"],null]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"],[8,[39,4],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,2],[\"calendar.future_trends.tooltip\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__0 u--text--sm\"],[12],[1,[28,[35,2],[\"calendar.future_trends.sub_title\"],[[\"dateRange\"],[[30,2]]]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,3],[[[1,\"    \"],[10,0],[14,0,\"cCA--futureTrends__content__loading\"],[12],[1,\"\\n      \"],[8,[39,6],[[24,0,\"u--text--light u--text--center\"]],[[\"@text\"],[[28,[37,2],[\"calendar.future_trends.loading\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,4,[\"length\"]],[[[1,\"    \"],[10,0],[14,0,\"cCA--futureTrends__content__items\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,4]],null]],null],null,[[[1,\"        \"],[8,[39,9],null,[[\"@closeAction\",\"@trend\"],[[30,6],[30,5]]],null],[1,\"\\n\"]],[5]],null],[1,\"    \"],[13],[1,\"\\n    \"],[8,[39,10],null,[[\"@closeAction\"],[[30,6]]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"cCA--futureTrends__content__error\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"warning\"],[[\"class\"],[\"o--icon o--icon--lg\"]]]],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[\"alerts.generic_error_message\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]],[]]],[13]],[\"@showFutureTrendsDropdown\",\"@dateRangeFormatted\",\"@isLoading\",\"@todaysTopHashtags\",\"trend\",\"@closeAction\"],false,[\"concat-classes\",\"unless\",\"t\",\"svg-jar\",\"ember-tooltip\",\"if\",\"shared/ui/calculating-state\",\"each\",\"-track-array\",\"calendar/future-trends/trend\",\"calendar/future-trends/footer\"]]",
    "moduleName": "calendar/components/calendar/future-trends/body.hbs",
    "isStrictMode": false
  });
  // body.ts

  class FutureTrendsBodyComponent extends _component2.default {}
  _exports.default = FutureTrendsBodyComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FutureTrendsBodyComponent);
});